export const cn = (...cls: (string | false | null | undefined)[]) => cls.filter(Boolean).join(" ");

export const getInitials = (name?: string) => {
  if (!name) return "GU";
  const parts = name.split(" ").filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};
